var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{attrs:{"color":"secondary","rounded":"","dense":""},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},_vm._l((_vm.items),function(item,index){return _c('v-btn',{key:index,attrs:{"value":item.value,"small":""}},[_c('span',{staticClass:"text-notransform"},[_vm._v(_vm._s(item.text))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }